import { render, staticRenderFns } from "./ShelfByArgs.vue?vue&type=template&id=5822afaa"
import script from "./ShelfByArgs.vue?vue&type=script&lang=js"
export * from "./ShelfByArgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports